import React, { useEffect, useState } from 'react';
import { Form, FormInstance, Select } from 'antd';

import { FormFieldLabel } from './FormFieldLabel';
import { StyledFormItem } from './FormInput';
import { FormSelectProps } from './FormSelect';

export type FormSelectOrAddItemProps = FormSelectProps & {
  form?: FormInstance;
};

export const FormSelectOrAddItem: React.FC<FormSelectOrAddItemProps> = ({
  name,
  label,
  options,
  allowClear = true,
  form,
  required,
  onChange,
  rules,
  dependencies,
  preserve,
}) => {
  const fieldValue = Form.useWatch(name, form);
  const [value, setValue] = useState(fieldValue?.toString() ?? '');

  useEffect(() => {
    setValue(fieldValue?.toString() ?? '');
  }, [fieldValue]);

  return (
    <StyledFormItem
      name={name}
      label={<FormFieldLabel required={required}>{label}</FormFieldLabel>}
      rules={rules}
      dependencies={dependencies}
      preserve={preserve}
    >
      <Select
        showSearch
        allowClear={allowClear}
        filterOption={(input, option) =>
          (option?.label?.toString() ?? '').toLowerCase().includes(input.toString().toLowerCase())
        }
        options={options.map((option) => ({
          value: option.value,
          label: option.content,
        }))}
        onChange={onChange}
        onSearch={(value) => {
          setValue(value);
        }}
        onSelect={(value) => {
          setValue(value.toString());
        }}
        onBlur={() => {
          if (value) {
            form?.setFieldValue(name, value);
          }
        }}
      />
    </StyledFormItem>
  );
};
